<template>
  <template v-if="centerOrder">
    <h6>
      Servisni nalogi v bližini <small class="text-muted">{{ subTitle }}</small>
    </h6>
    <p v-if="!orders.length" class="text-muted">Ni nalogov v bližini.</p>
    <ul v-else>
      <li v-for="so in orders" :key="so.id">
        <input
          type="checkbox"
          class="form-check-input"
          v-model="so.selected"
          :disabled="so.id === centerOrder.id"
        />
        <OrderBadge :workOrder="so" />
        <strong>{{ so.facilityName }}</strong>
        <small class="text-muted">{{ so.subject }}</small>
        <router-link :to="{ name: 'ServiceOrder', params: { workOrderId: so.id } }" target="_blank">{{
          so.orderNumber
        }}</router-link>
      </li>
    </ul>
  </template>
</template>

<script setup>
import { ref, watch } from "vue"
import { useWorkOrders } from "../composition-api/useWorkOrders"

defineOptions({ name: "NearbyServiceOrders" })

const props = defineProps({
  centerOrder: {
    type: Object,
    default: null,
  },
})

const { filters, orders, getOrdersAsync, paging } = useWorkOrders("Service")
const subTitle = ref("")

watch(
  () => props.centerOrder,
  async () => {
    if (props.centerOrder === null) {
      orders.value = []
      return
    }
    paging.value.itemsPerPage = 30
    filters.status = "Triage,Active"
    filters.nearFacilityId = props.centerOrder.facilityId
    filters.isSpecial = props.centerOrder.isSpecial
    subTitle.value = filters.status + "; 5km; "
    subTitle.value += props.centerOrder.isSpecial ? "s +" : "brez +"
    await getOrdersAsync()
    const currentOrder = orders.value.find((o) => o.id === props.centerOrder.id)
    if (currentOrder) {
      currentOrder.selected = true
    }
  },
  { immediate: true },
)

defineExpose({ orders })
</script>

<style scoped>
h6 {
  margin-bottom: 0.5rem;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;

  & > li {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    margin-bottom: 0.25rem;

    & > input {
      margin: 0;
    }

    & > small {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
